import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { bootstrapVoiceForge } from "./forge/bootstrap";

// VoiceForge suite overlays: OAuth hash, Binder ?endpoint=, skins/motion
bootstrapVoiceForge();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
